<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        11.14
        <br />2017
      </span>
      <span class="tiel">双创双新博览会 美菜开创农业服务新模式</span>
    </div>
    <div class="mat-content">
      <div
        class="tet-js"
      >11月9日—12日，首届全国“互联网+”现代农业新技术和新农民创业创新博览会(简称“双新双创”博览会)在苏州举行，美菜网与阿里巴巴、京东、苏宁等互联网巨头企业一起应邀出席本次大会，创始人刘传军在此次大会上进行了主题为《美菜大源头战略 开创农业服务新模式》的分享</div>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a7_01.jpg" width="640" />
      </p>
      <div style="text-align: center" class="tet-js">美菜网ceo刘传军</div>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>互联网+农业：美菜插上腾飞的翅膀
      </div>
      <div class="tet-js">
        刘传军在主题演讲中介绍了三年来的发展路径，他讲道，美菜网是一家互联网+农业的创业公司，致力于通过互联网的方式来改变农业、农村和农民，目前的业务已经覆盖全国近50个城市。2017年底，美菜网农产品上行将超过百亿元规模，其中，果蔬产品将超过8亿斤。
        <br />
        <br />刘传军还向我们讲述了两个“新农民”的典型案例。一位是随着美菜业务发展的传统农民，他享受到农业互联网的红利，规模由4亩地变成400亩地，成为了“新农民”。另一位是拥抱创新的城里人，跟随着美菜模式，带着城市的资源和思路，返乡创业。
        <br />
        <br />他的下一个话题，说起了精准扶贫。今年5月，美菜网积极响应精准扶贫的号召，发起了全网助销扶贫菜的公益项目，联合美菜网众多供应商结成扶贫菜帮扶联盟。刘传军表示，美菜目前已积极投身到“精准扶贫”当中，为精准扶贫提供有力支持。未来，会更注重扶贫同扶志、扶智相结合，让贫困地区百姓的生活更美好。
        <br />
        <br />
      </div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>大源头战略：美菜加强科技创新
      </div>
      <div
        class="tet-js"
      >刘传军表示，下一步，美菜网将启动大源头战略，将供应链下沉到农村市场，以现有中央仓为支点，将以探索成功的标准化模式覆盖三、四、五线城市，供应链进一步下沉到农村市场，推动农村农业的发展，落实供给侧结构性改革，为全国上千个乡镇的农业服务。</div>
    </div>
    <!--<div class="mat-content">-->
    <!--<p align="center"><img src="/assets/images/new-img/a7_02.jpg" width="640"></p>-->
    <!--<div style="text-align: center" class="tet-js">美菜网创始人刘传军现场演讲</div>-->
    <!--</div>-->
    <div class="mat-content">
      <div class="tet-js">
        在互联网+的时代，美菜网以互联网+农业的方式，利用互联网技术和自身的渠道优势，创新农村农业服务，促进农产品流通，解决销路给农民安心的保障，并要求源头端建立生产标准，保证上行农产品的质量安全，从而实现良性循环。
        <br />
        <br />据悉，美菜正在紧锣密鼓的研发针对生鲜农产品的云仓体系，这一创新之举将大大的提升美菜农产品供应链系统，对未来美菜的全国扩张起到至关重要的作用。
        <br />
        <br />借此次全国互联网+现代农业双新双创博览会的契机，刘传军表达了他的新思考和希冀：“未来，美菜的新农业模式将进一步缩短农村和城市的距离，助力改变中国农业，并推动农业产业化发展。同时，不忘初心、牢记使命，为8亿农民谋幸福，让农村生活更美好。”
        <br />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
